import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Newspaper, X } from "lucide-react";
import { MEDIA } from "@/content";

export default function MediaWall() {
  const [active, setActive] = useState(null);

  return (
    <section id="media" data-testid="media-section" className="py-20 lg:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-12"
        >
          <p className="font-head font-bold text-sm tracking-[0.2em] text-terracotta mb-4 flex items-center gap-2">
            <Newspaper className="w-4 h-4" />
            મીડિયામાં અમે
          </p>
          <h2 className="font-display text-ink text-4xl sm:text-5xl leading-snug">
            અખબારોમાં છપાયેલી <span className="text-saffron">અમારી સેવા</span>
          </h2>
          <p className="mt-5 text-ink/70 text-base md:text-lg leading-relaxed">
            અમારી કામગીરી વર્ષોથી ગુજરાતના અગ્રણી અખબારોમાં નોંધાઈ છે — આ
            પ્રસિદ્ધિ અમારી પારદર્શકતાનો પુરાવો છે.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA.map((m, i) => (
            <motion.button
              key={m.src}
              data-testid={`media-item-${i}`}
              onClick={() => setActive(m)}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className={`group text-left rounded-2xl border border-stone-200 bg-cream overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(0,0,0,0.1)] transition-all duration-200 ${
                i === 0 || i === 5 ? "lg:row-span-2" : ""
              }`}
            >
              <div className={`overflow-hidden ${i === 0 || i === 5 ? "h-72 sm:h-96" : "h-56 sm:h-64"}`}>
                <img
                  src={m.src}
                  alt={m.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <p className="font-head font-bold text-ink text-base leading-snug">
                  {m.title}
                </p>
                <p className="font-head text-xs text-ink/50 mt-1.5">{m.tag}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="media-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[100] bg-ink/90 backdrop-blur-sm flex items-center justify-center p-5"
          >
            <button
              data-testid="media-lightbox-close"
              onClick={() => setActive(null)}
              className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-cream hover:bg-terracotta transition-colors"
              aria-label="બંધ કરો"
            >
              <X className="w-5 h-5" />
            </button>
            <motion.img
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.92, opacity: 0 }}
              transition={{ duration: 0.25 }}
              src={active.src}
              alt={active.title}
              onClick={(e) => e.stopPropagation()}
              className="max-w-full max-h-[85vh] rounded-2xl shadow-2xl object-contain bg-white"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
